import React, { Component } from 'react';

class VerificationFailScene extends Component {

  componentWillMount() {
    document.body.classList.add('verification-failed');
  }

  componentWillUnmount() {
    document.body.classList.remove('verification-failed');
  }

  render() {
    return (
      <div className="verificationFailed">
        <h1>Verification Failed</h1>
        <a href="g4ellis://verification/failure" className="btn btn-danger bold-button px-4">Go to Verification Step</a>
      </div>
    );
  }
}

export default VerificationFailScene;